import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "./firebase";
import { Link } from "react-router-dom";
import Header from "../../common_components/Header";
import Footer from "../../common_components/Footer";
import ConnectWithUs from "../../common_components/ConnectWithUs";
import { Icon } from "react-icons-kit";
import { eye } from "react-icons-kit/feather/eye";
import { eyeOff } from "react-icons-kit/feather/eyeOff";

function Login() {
  const [data, setData] = useState({
    email: "",
    password: "",
  });

  const { email, password } = data;
  const change = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const submit = (e) => {
    e.preventDefault();
    console.log("login pressed")
    signInWithEmailAndPassword(auth, email, password).then(() =>
      alert("successful")
    );
  };

  const [type, setType] = useState("password");
  const [icon, setIcon] = useState(eyeOff);

  const handleToggle = () => {
    if (type === "password") {
      setIcon(eye);
      setType("text");
    } else {
      setIcon(eyeOff);
      setType("password");
    }
  };

  return (
    <React.Fragment>
      <Header></Header>
      <div className="register__content">
        <div className="left-content" id="left-content">
          <div className="top-part">
            <h2>Let's Reconnect</h2>
            <p>Alumni Association</p>
          </div>
          <div className="middle-content"></div>
          <div className="bottom-part">
            <h2>VIT AP</h2>
            {/* <Link className="register-btn btn btn-primary" style={{"margin":"0px"}} aria-current="page" to="/register">Register</Link> */}
            <p>
              A professional platform to connect, share and recreate wonderful
              memories with distinguished Alumni.
            </p>
          </div>
        </div>

        <div className="right-content">
          <div className="middle-content">
            <h3>Login Here</h3>

            <div className="form">
              <form onSubmit={submit} className="rightSide">
                <input
                  type="email"
                  placeholder="Enter email *"
                  name="email"
                  onChange={change}
                  value={email}
                />
                <input
                  type={type}
                  placeholder="Password *"
                  name="password"
                  onChange={change}
                  value={password}
                />
                <span onClick={handleToggle}>
                  <Icon icon={icon} size={15} />
                </span>
                <Link aria-current="page" to="/resetPassword">
                  Forgot Password?
                </Link>{" "}
                <br />
                <button className="submit btn btn-primary" type="submit"> Submit</button>
              </form>

              <p>
                Don't have an account?{" "}
                <Link aria-current="page" to="/register">
                  Register Here
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
      <ConnectWithUs />
      <Footer></Footer>
    </React.Fragment>
  );
}

export default Login;
